import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useUnits } from "../context/UnitsContext";
import { Button } from "../components/ui/button";
import { LogOut, PawPrint } from "lucide-react";

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const { units, toggle } = useUnits();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <div className="min-h-screen">
      <header className="sticky top-0 z-30 border-b border-border/70 bg-background/80 backdrop-blur-xl">
        <div className="max-w-6xl mx-auto flex items-center justify-between px-6 py-4">
          <Link
            to={user ? "/dashboard" : "/"}
            className="flex items-center gap-2 text-foreground group"
            data-testid="brand-home-link"
          >
            <span className="w-9 h-9 rounded-full bg-primary/15 text-primary flex items-center justify-center group-hover:bg-primary/25 transition">
              <PawPrint size={18} />
            </span>
            <span className="font-display text-lg font-semibold tracking-tight">
              Cat Kidney <span className="text-primary">Compass</span>
            </span>
          </Link>

          <div className="flex items-center gap-3">
            <button
              onClick={toggle}
              data-testid="units-toggle-button"
              className="relative flex items-center rounded-full border border-border bg-secondary p-1 text-xs font-medium"
              aria-label="Toggle units"
            >
              <span
                className={`px-3 py-1 rounded-full transition-all duration-300 ${
                  units === "US" ? "bg-primary text-primary-foreground shadow-sm" : "text-muted-foreground"
                }`}
              >
                US · mg/dL
              </span>
              <span
                className={`px-3 py-1 rounded-full transition-all duration-300 ${
                  units === "SI" ? "bg-primary text-primary-foreground shadow-sm" : "text-muted-foreground"
                }`}
              >
                SI · µmol/L
              </span>
            </button>

            {user && (
              <>
                <span className="hidden sm:block text-sm text-muted-foreground" data-testid="user-greeting">
                  Hi, {user.name}
                </span>
                <Button
                  onClick={handleLogout}
                  variant="ghost"
                  size="sm"
                  data-testid="logout-button"
                  className="rounded-full"
                >
                  <LogOut size={16} className="mr-1.5" /> Logout
                </Button>
              </>
            )}
          </div>
        </div>
      </header>

      <main className="max-w-6xl mx-auto px-6 py-10">{children}</main>

      <footer className="max-w-6xl mx-auto px-6 py-10 text-xs text-muted-foreground">
        Guidance is educational and based on the IRIS 2023 CKD guidelines.
        Always work with your veterinarian for diagnosis and treatment decisions.
        <span className="opacity-0 ml-1">{location.pathname}</span>
      </footer>
    </div>
  );
}
